import localStorageData from "./localStorageData";  
const prefix = "tbcol_width_";

const tableModal = {
  loadColumnWidth: (pageType, id, width = 150) => {
    if (id === 'checkbox' || id === 'expander') return width;
    // If the user has saved a width for this column, use that instead
    const pageKey = `${prefix}${pageType}`;
    const cachedWidths = localStorageData.getData(pageKey);
    return cachedWidths[id] || width;
  },
  updateColumnWidths: (pageType, { id, width }) => {
    if (id === 'checkbox' || id === 'expander') return;

    const pageKey = `${prefix}${pageType}`;
    const columnWidths = localStorageData.getData(pageKey);
    columnWidths[id] = width;
    localStorageData.setData(pageKey, columnWidths);
  }
}

export default tableModal;